import React, { useState } from 'react';
import { Popup } from 'devextreme-react/popup';
import { FeedbackMessages } from '../../../helpers/enums/feedback.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { feedbackIcons } from '../../../../../../../apps/admin/src/common/functions/feedbackIcons.ts';

export interface IFeedbackModalOptions {
    isOpen: boolean;
    confirmFeedbackCallback(category: number, type: number, comment: string): void;
    cancelFeedbackCallback(): void;
}

export const FeedbackModal = ({
    isOpen,
    confirmFeedbackCallback,
    cancelFeedbackCallback,
}: IFeedbackModalOptions): React.ReactElement => {
    const [comment, set_comment] = useState('');
    const [category, set_category] = useState(0);
    const [feedbackStatement, set_feedbackStatement] = useState('');
    const [type] = useState(1); // Currently, only one FeedbackType exists (Draw feedback).
    const [disableButton, set_disableButton] = useState(false);

    const _handleConfirm = () => {
        set_disableButton(true);
        confirmFeedbackCallback(category, type, comment);
    };
    const _handleCancel = () => cancelFeedbackCallback();

    const [selectedIcon, set_selectedIcon] = useState<number | null>(null);

    const handleClick = (id: number) => {
        set_selectedIcon(id);
        set_category(id);
        switch (id) {
            case 1:
                set_feedbackStatement(FeedbackMessages.Great);
                return;
            case 2:
                set_feedbackStatement(FeedbackMessages.Good);
                return;
            case 3:
                set_feedbackStatement(FeedbackMessages.Neutral);
                return;
            case 4:
                set_feedbackStatement(FeedbackMessages.Negative);
                return;
            case 5:
                set_feedbackStatement(FeedbackMessages.VeryNegative);
                return;
            default:
                return;
        }
    };

    return (
        <div>
            <Popup
                visible={isOpen}
                onHiding={_handleCancel}
                aria-labelledby='alert-dialog-title'
                hideOnOutsideClick={true}
                showCloseButton={false}
            >
                <div>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal feedback'
                            tabIndex={-1}
                            role='dialog'
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>Share Your Feedback</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={_handleCancel}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='feedback-success-container'>
                                    <span className='feedback-success-text'>SUCCESS!</span>
                                    <span className='feedback-draw-text'>Draw request submitted</span>
                                </div>
                                <h2 className='feedback-experience-text'>How was your experience?</h2>
                                <div className='feedback-icons'>
                                    {feedbackIcons.map(({ id, solid, regular, color, title }) => (
                                        <button
                                            onClick={() => handleClick(id)}
                                            title={title}
                                        >
                                            <FontAwesomeIcon
                                                key={id}
                                                icon={selectedIcon === id ? solid : regular}
                                                color={color}
                                            />
                                        </button>
                                    ))}
                                </div>
                                <div className='columns'>
                                    <label
                                        htmlFor='notes'
                                        className='feedback-label-text'
                                    >
                                        {feedbackStatement}
                                    </label>
                                    <textarea
                                        style={{
                                            width: '100%',
                                        }}
                                        rows={4}
                                        id='notes'
                                        value={comment}
                                        onChange={(e) => set_comment(e.target.value)}
                                        required={true}
                                        placeholder='Enter feedback here...'
                                        maxLength={400}
                                    />
                                </div>
                                <div className='modal-button-footer'>
                                    <button
                                        type='button'
                                        className='button primary'
                                        onClick={_handleConfirm}
                                        disabled={!feedbackStatement || disableButton}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type='button'
                                        className='button hollow'
                                        onClick={_handleCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        </div>
    );
};
